import { SEPARATOR } from '@hakimo-ui/hakimo/data-access';

export function getCameraGroupSearchParams(
  page?: number,
  pageSize?: number,
  name?: string,
  locationIds?: string[]
): string {
  const params = new URLSearchParams();

  if (page) {
    params.append('page', String(page));
  }

  if (pageSize) {
    params.append('pageSize', String(pageSize));
  }

  if (name && name.length > 0) {
    params.append('name', name);
  }

  if (locationIds && locationIds.length > 0) {
    params.append('locationIds', locationIds.join(SEPARATOR));
  }

  return params.toString();
}
